"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _constants2 = _interopRequireDefault(require("../../common/constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  title: 'Choose info layout',
  description: "Choose the layout you want for your texts, you can choose to separate the texts and the items\n  so you can style them separately.",
  isRelevant: function isRelevant(styleParams) {
    return (styleParams.allowTitle || styleParams.allowDescription) && styleParams.groupSize === 1 && styleParams.isVertical && styleParams.titlePlacement !== _constants2["default"].placements.SHOW_ON_HOVER;
  },
  options: (0, _utils.createOptions)('infoType'),
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants2["default"].infoType.NO_BACKGROUND
};
exports["default"] = _default;